import React from 'react';

export default function Table({ selectedFeature }) {

  return (
    <div>
      <div className="w-full mx-3 my-1 lg:my-6" id="resultTable">
        <table className='w-full border-collapse text-right'>
          <tbody>
            <tr>
              <th id="resultprovince" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-r-0 border-t-0">استان: {selectedFeature ? selectedFeature.province_name_fa : '-'} </th>
              <th id="resultcounty" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-l-0 border-t-0">شهرستان:{selectedFeature ? selectedFeature.county_name_fa : '-'}</th>
            </tr>
            <tr>
              <th id="resultregion" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-r-0">بخش: {selectedFeature ? selectedFeature.region_name_fa : '-'}</th>
              <th id="resultloc_name" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-l-0">ایستگاه: {selectedFeature ? selectedFeature.loc_name_fa : '-'}</th>
            </tr>
            <tr>
              <th id="resultLongitude" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-r-0">طول: {selectedFeature ? selectedFeature.lon : '-'}</th>
              <th id="resultLatitude" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-l-0">عرض: {selectedFeature ? selectedFeature.lat : '-'}</th>
            </tr>
            <tr>
              <th id="resultElevation" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-r-0 border-b-0">ارتفاع: {selectedFeature ? selectedFeature.elevation : '-'}</th>
              <th id="resultwatershed" className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-l-0 border-b-0">
                کد ایستگاه: {selectedFeature ? (selectedFeature.stationpkid || selectedFeature.loc_id) : '-'}
              </th>

            </tr>
            <tr>
              <th colSpan={2} className="border border-solid-[#d0cfd4] p-2 align-right text-[#736e7e] font-[myFont] text-[12px] border-r-0 border-b-0 border-l-0">
              نوع ایستگاه: {selectedFeature?.sourceFile === 'insurance' && 'نقاط بیمه'}
                {selectedFeature?.sourceFile === 'sam' && 'نقاط سمیتیو'}
                {selectedFeature?.sourceFile === 'station' && 'ایستگاه های سینوپتیک هواشناسی'}
                {!selectedFeature?.sourceFile && '-'}
              </th>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  );
}
